import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRIPS_SUMMARY } from 'api/query-keys.ts';
import type { TGetTripTotalsReq } from 'api/swagger';
import type { ITripFilter } from 'shared/stores/use-trip-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs.ts';
import type { IWithPagination } from 'types/api-query.ts';

interface IParams extends IWithPagination {
  search?: string;
  filters?: ITripFilter;
  isHints?: boolean;
  isSkip?: boolean;
}

export const useGetTripsSummary = (params?: IParams) => {
  const { search, filters, isSkip } = params || {};

  const qs = new URLSearchParams();
  if (search) qs.set('filter[search]', search);
  if (filters) setFiltersToQs<ITripFilter>(qs, filters);

  return useQuery<TGetTripTotalsReq>({
    queryKey: [TRIPS_SUMMARY, qs.toString()],
    queryFn: async () => {
      const { data } = await http.get<TGetTripTotalsReq>(`/v1/trips/total?${qs.toString()}`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 10,
    cacheTime: 10,
    enabled: !isSkip,
  });
};
